// ============================================================
// src/hooks/useQuickActionBadges.ts
// Changements :
// ============================================================

import { useState, useEffect } from 'react';
import { collection, query, where, getCountFromServer } from 'firebase/firestore';
import { db } from '@/lib/firebase';

interface QuickActionBadges {
  triage: number;
  nda: number;
  lenderOffers: number;
  verifications: number; // NOUVEAU
}

export function useQuickActionBadges() {
  const [badges, setBadges] = useState<QuickActionBadges>({
    triage: 0, nda: 0, lenderOffers: 0, verifications: 0, // NOUVEAU
  });

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        // Deals en phase de soumission (triage)
        const triageSnap = await getCountFromServer(
          query(collection(db, 'deals'), where('current_stage', '==', 'submission'))
        );

        // NDA en attente de signature
        const ndaSnap = await getCountFromServer(
          query(
            collection(db, 'dealDocuments'),
            where('document_type', '==', 'nda'),
            where('status', '==', 'pending_signature')
          )
        );

        // LOI en attente de signature
        const loiSnap = await getCountFromServer(
          query(
            collection(db, 'dealDocuments'),
            where('document_type', '==', 'loi'),
            where('status', '==', 'pending_signature')
          )
        );

        // NOUVEAU — Vérifications d'identité en attente de révision manuelle
        const verificationsSnap = await getCountFromServer(
          query(
            collection(db, 'staffNotifications'),
            where('type', '==', 'verification_review'),
            where('read', '==', false)
          )
        );

        setBadges({
          triage: triageSnap.data().count,
          nda: ndaSnap.data().count,
          lenderOffers: loiSnap.data().count,
          verifications: verificationsSnap.data().count, // NOUVEAU
        });
      } catch (err) {
        console.error('Failed to fetch quick action badges:', err);
      }
    };

    fetchCounts();
    const interval = setInterval(fetchCounts, 60000);
    return () => clearInterval(interval);
  }, []);

  return badges;
}